module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"yes":"Oui","no":"Non"},"en":{"yes":"Yes","no":"No"}}')
  delete Component.options._Ctor
}
